module.exports = __webpack_public_path__ + "img/hockey.758dd219.svg";